import React from 'react';
import '../template-file-css/document-file-template.css';


export const BFCS_AdultAssessment1915 = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='BFCS_AdultAssessment1915' className='file-pdf-document'>
            <div className='file-template'>


                <h2>Demographic Information</h2>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Gender Expression</span>
                            <input type="text" id="txtGenderExpression" name="txtGenderExpression" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Marital Status</span>
                            <input type="text" id="txtMaritalStatus" name="txtMaritalStatus" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Locus</span>
                            <input type="text" id="txtLocus" name="txtLocus" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Primary Diagnosis</span>
                            <input type="text" id="txtPrimaryDiagnosis" name="txtPrimaryDiagnosis" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h2>Behavioral Health History</h2>
                <p className='w-750'>
                    <span className='eleHeader'>Chief Complaint</span>
                    <span className='small'>(Major symptoms, difficulties, and/or Issues as they relate to behavioral health –in recipient's own words/quoted.)</span>
                    <textarea id="txtChiefComplaint" name="txtChiefComplaint" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Presenting Problem/History of Present Illness</span>
                    <span className='small'>(Including recipient's reason for seeking services, precipitating factors, symptoms, behavioral and functioning impacts, onset/course of issues, current behavioral health providers, services sought and recipient expectation.)</span>
                    <textarea id="txtHistoryOfIllness" name="txtHistoryOfIllness" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Behavioral Health Provider Name</span>
                            <input type="text" id="txtCurrentBehavioralHealthProviderName" name="txtCurrentBehavioralHealthProviderName" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone Number</span>
                            <input type="text" id="txtPhoneNumber" name="txtPhoneNumber" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h2><b>Past Psychiatric History</b>
                    <span className='small'>(First onset of illness, past diagnostic and treatment history, medications, hospitalizations)</span>
                </h2>
                <p className='w-750'>
                    <span className='eleHeader'>Prior Outpatient Mental Health Treatment</span>
                </p>


                <table>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbMentalHealthTreatment_No" name="rbMentalHealthTreatment" className='add-only' value="No" /> No &nbsp;&nbsp;
                            <input type="radio" id="rbMentalHealthTreatment_Yes" name="rbMentalHealthTreatment" className='add-only' value="Yes" /> Yes
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span>Details:</span>
                    <textarea id="txtDetailPriorOutpatientMentalHealthTreatment" name="txtDetailPriorOutpatientMentalHealthTreatment" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>PsychiatricHospitalizations</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbPsychiatricHospitalizations_No" name="rbPsychiatricHospitalizations" className='add-only' value="No" /> No &nbsp;&nbsp;
                            <input type="radio" id="rbPsychiatricHospitalizations_Yes" name="rbPsychiatricHospitalizations" className='add-only' value="Yes" /> Yes
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span>Details:</span>
                    <textarea id="txtDetailPsychiatricHospitalizations" name="txtDetailPsychiatricHospitalizations" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Additional History/Comments</span>
                    <textarea id="txtAdditionalComments" name="txtAdditionalComments" className='add-only'></textarea>
                </p>
                <h2>Substance Abuse/Dependence
                    <span className='small'>(Past use of primary, secondary & tertiary current substance, incl. type, freq, method & age of 1st use.)</span>
                </h2>
                <p className='w-750'>

                    <span className='eleHeader'>Check any/all that apply in past 12 months</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAlcoholUse" name="cbAlcoholUse" className='add-only' value="AlcoholUse" />
                            Alcohol Use</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIllegalDrugUse" name="cbIllegalDrugUse" className='add-only' value="IllegalDrugUse" />
                            Illegal Drug Use</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbInjectedDrugUse" name="cbInjectedDrugUse" className='add-only' value="InjectedDrugUse" />
                            Injected Drug Use</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbTobaccoProductUse" name="cbTobaccoProductUse" className='add-only' value="TobaccoProductUse" />
                            Tobacco Product Use</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPrescriptionDrugsAbuse" name="cbPrescriptionDrugsAbuse" className='add-only' value="PrescriptionDrugsAbuse" />
                            Prescription Drugs Abuse</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbNonPrescriptionOtcAbuse" name="cbNonPrescriptionOtcAbuse" className='add-only' value="NonPrescriptionOtcAbuse" />
                            Non-Prescription (OTC) abuse</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAlcoholAndOrDrugOverdose" name="cbAlcoholAndOrDrugOverdose" className='add-only' value="AlcoholAndOrDrugOverdose" />
                            Alcohol and/or Drug Overdose</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAlcoholAndOrDrugWithdrawal" name="cbAlcoholAndOrDrugWithdrawal" className='add-only' value="AlcoholAndOrDrugWithdrawal" />
                            Alcohol and/or Drug Withdrawal</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbProblemsCauseByGambling" name="cbProblemsCauseByGambling" className='add-only' value="ProblemsCauseByGambling" />
                            Problems Cause by Gambling</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbTroubleStoppingAnySubstance" name="cbTroubleStoppingAnySubstance" className='add-only' value="TroubleStoppingAnySubstance" />
                            Trouble Stopping Any Substance</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCaffeineUse" name="cbCaffeineUse" className='add-only' value="CaffeineUse" />
                            Caffeine Use</td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbOtherDescribeAbuse" name="cbOtherDescribeAbuse" className='add-only' value="OtherDescribeAbuse" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtOtherDescribeAbuse" name="txtOtherDescribeAbuse" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Substance Abuse Treatment History</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbNone" name="cbNone" className='add-only' value="None" />
                            None
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbOutpatient" name="cbOutpatient" className='add-only' value="Outpatient" />
                            Outpatient
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbIntensiveOutpatient" name="cbIntensiveOutpatient" className='add-only' value="IntensiveOutpatient" />
                            Intensive Outpatient
                        </td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbResidentialInpatient" name="cbResidentialInpatient" className='add-only' value="ResidentialInpatient" />
                            Residential/Inpatient
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbDetox" name="cbDetox" className='add-only' value="Detox" />
                            Detox
                        </td>
                        <td className='w-187'></td>
                        <td className='w-187'></td>
                        <td className='w-187'></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbOtherDescribeTreatmentHistory" name="cbOtherDescribeTreatmentHistory" className='add-only' value="OtherDescribeTreatmentHistory" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtOtherDescribeTreatmentHistory" name="txtOtherDescribeTreatmentHistory" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <th className='w-150'>SUBSTANCE TYPE<br />
                            <span className='small'>Include all used in last 30 days</span></th>
                        <th className='w-75'>AGE OF<br />
                            1ST USE</th>
                        <th className='w-75'>YEARS IN<br />
                            LIFETIME</th>
                        <th className='w-75'>DAYS IN<br />
                            PAST 30</th>
                        <th className='w-75'>DAYS SINCE<br />
                            LAST USE</th>
                        <th className='w-100'>AMOUNT</th>
                        <th className='w-200'>ROUTE OF ADMINISTRATION</th>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtSubstanceType_1" name="txtSubstanceType_1" className='add-only' /></td>
                        <td className='w-75'>
                            <input type="text" id="txtSubstanceAge_1" name="txtSubstanceAge_1" className='add-only' /></td>
                        <td className='w-75'>
                            <input type="text" id="txtSubstanceYears_1" name="txtSubstanceYears_1" className='add-only' /></td>
                        <td className='w-75'>
                            <input type="text" id="txtSubstanceDays_1" name="txtSubstanceDays_1" className='add-only' /></td>
                        <td className='w-75'>
                            <input type="text" id="txtSubstanceDaysSins_1" name="txtSubstanceDaysSins_1" className='add-only' /></td>
                        <td className='w-100'>
                            <input type="text" id="txtSubstanceRoute_1" name="txtSubstanceRoute_1" className='add-only' /></td>
                        <td className='w-200'>
                            <input type="checkbox" id="cbSubstanceTypeOral_1" name="cbSubstanceTypeOral_1" className='add-only' value="Oral" />
                            Oral &nbsp;
                            <input type="checkbox" id="cbSubstanceTypeNasal_1" name="cbSubstanceTypeNasal_1" className='add-only' value="Nasal" />
                            Nasal &nbsp;
                            <input type="checkbox" id="cbSubstanceTypeSmoking_1" name="cbSubstanceTypeSmoking_1" className='add-only' value="Smoking" />
                            Smoking &nbsp;
                            <input type="checkbox" id="cbSubstanceTypeNonIvInjxn_1" name="cbSubstanceTypeNonIvInjxn_1" className='add-only' value="NonIvInjxn" />
                            Non-IV Injxn &nbsp;
                            <input type="checkbox" id="cbSubstanceTypeIv_1" name="cbSubstanceTypeIv_1" className='add-only' value="Iv" />
                            IV
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtSubstanceType_2" name="txtSubstanceType_2" className='add-only' /></td>
                        <td className='w-75'>
                            <input type="text" id="txtSubstanceAge_2" name="txtSubstanceAge_2" className='add-only' /></td>
                        <td className='w-75'>
                            <input type="text" id="txtSubstanceYears_2" name="txtSubstanceYears_2" className='add-only' /></td>
                        <td className='w-75'>
                            <input type="text" id="txtSubstanceDays_2" name="txtSubstanceDays_2" className='add-only' /></td>
                        <td className='w-75'>
                            <input type="text" id="txtSubstanceDaysSins_2" name="txtSubstanceDaysSins_2" className='add-only' /></td>
                        <td className='w-100'>
                            <input type="text" id="txtSubstanceRoute_2" name="txtSubstanceRoute_2" className='add-only' /></td>
                        <td className='w-200'>
                            <input type="checkbox" id="cbSubstanceTypeOral_2" name="cbSubstanceTypeOral_2" className='add-only' value="Oral" />
                            Oral &nbsp;
                            <input type="checkbox" id="cbSubstanceTypeNasal_2" name="cbSubstanceTypeNasal_2" className='add-only' value="Nasal" />
                            Nasal &nbsp;
                            <input type="checkbox" id="cbSubstanceTypeSmoking_2" name="cbSubstanceTypeSmoking_2" className='add-only' value="Smoking" />
                            Smoking &nbsp;
                            <input type="checkbox" id="cbSubstanceTypeNonIvInjxn_2" name="cbSubstanceTypeNonIvInjxn_2" className='add-only' value="NonIvInjxn" />
                            Non-IV Injxn &nbsp;
                            <input type="checkbox" id="cbSubstanceTypeIv_2" name="cbSubstanceTypeIv_2" className='add-only' value="Iv" />
                            IV
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtSubstanceType_3" name="txtSubstanceType_3" className='add-only' /></td>
                        <td className='w-75'>
                            <input type="text" id="txtSubstanceAge_3" name="txtSubstanceAge_3" className='add-only' /></td>
                        <td className='w-75'>
                            <input type="text" id="txtSubstanceYears_3" name="txtSubstanceYears_3" className='add-only' /></td>
                        <td className='w-75'>
                            <input type="text" id="txtSubstanceDays_3" name="txtSubstanceDays_3" className='add-only' /></td>
                        <td className='w-75'>
                            <input type="text" id="txtSubstanceDaysSins_3" name="txtSubstanceDaysSins_3" className='add-only' /></td>
                        <td className='w-100'>
                            <input type="text" id="txtSubstanceRoute_3" name="txtSubstanceRoute_3" className='add-only' /></td>
                        <td className='w-200'>
                            <input type="checkbox" id="cbSubstanceTypeOral_3" name="cbSubstanceTypeOral_3" className='add-only' value="Oral" />
                            Oral &nbsp;
                            <input type="checkbox" id="cbSubstanceTypeNasal_3" name="cbSubstanceTypeNasal_3" className='add-only' value="Nasal" />
                            Nasal &nbsp;
                            <input type="checkbox" id="cbSubstanceTypeSmoking_3" name="cbSubstanceTypeSmoking_3" className='add-only' value="Smoking" />
                            Smoking &nbsp;
                            <input type="checkbox" id="cbSubstanceTypeNonIvInjxn_3" name="cbSubstanceTypeNonIvInjxn_3" className='add-only' value="Non-IV Injxn" />
                            Non-IV Injxn
                            <input type="checkbox" id="cbSubstanceTypeIv_3" name="cbSubstanceTypeIv_3" className='add-only' value="Iv" />
                            IV
                        </td>
                    </tr>

                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtSubstanceType_4" name="txtSubstanceType_4" className='add-only' /></td>
                        <td className='w-75'>
                            <input type="text" id="txtSubstanceAge_4" name="txtSubstanceAge_4" className='add-only' /></td>
                        <td className='w-75'>
                            <input type="text" id="txtSubstanceYears_4" name="txtSubstanceYears_4" className='add-only' /></td>
                        <td className='w-75'>
                            <input type="text" id="txtSubstanceDays_4" name="txtSubstanceDays_4" className='add-only' /></td>
                        <td className='w-75'>
                            <input type="text" id="txtSubstanceDaysSins_4" name="txtSubstanceDaysSins_4" className='add-only' /></td>
                        <td className='w-100'>
                            <input type="text" id="txtSubstanceRoute_4" name="txtSubstanceRoute_4" className='add-only' /></td>
                        <td className='w-200'>
                            <input type="checkbox" id="cbSubstanceTypeOral_4" name="cbSubstanceTypeOral_4" className='add-only' value="Oral" />
                            Oral &nbsp;
                            <input type="checkbox" id="cbSubstanceTypeNasal_4" name="cbSubstanceTypeNasal_4" className='add-only' value="Nasal" />
                            Nasal &nbsp;
                            <input type="checkbox" id="cbSubstanceTypeSmoking_4" name="cbSubstanceTypeSmoking_4" className='add-only' value="Smoking" />
                            Smoking &nbsp;
                            <input type="checkbox" id="cbSubstanceTypeNonIvInjxn_4" name="cbSubstanceTypeNonIvInjxn_4" className='add-only' value="NonIvInjxn" />
                            Non-IV Injxn &nbsp;
                            <input type="checkbox" id="cbSubstanceTypeIv_4" name="cbSubstanceTypeIv_4" className='add-only' value="Iv" />
                            IV
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtSubstanceType_5" name="txtSubstanceType_5" className='add-only' /></td>
                        <td className='w-75'>
                            <input type="text" id="txtSubstanceAge_5" name="txtSubstanceAge_5" className='add-only' /></td>
                        <td className='w-75'>
                            <input type="text" id="txtSubstanceYears_5" name="txtSubstanceYears_5" className='add-only' /></td>
                        <td className='w-75'>
                            <input type="text" id="txtSubstanceDays_5" name="txtSubstanceDays_5" className='add-only' /></td>
                        <td className='w-75'>
                            <input type="text" id="txtSubstanceDaysSins_5" name="txtSubstanceDaysSins_5" className='add-only' /></td>
                        <td className='w-100'>
                            <input type="text" id="txtSubstanceRoute_5" name="txtSubstanceRoute_5" className='add-only' /></td>
                        <td className='w-200'>
                            <input type="checkbox" id="cbSubstanceTypeOral_5" name="cbSubstanceTypeOral_5" className='add-only' value="Oral" />
                            Oral &nbsp;
                            <input type="checkbox" id="cbSubstanceTypeNasal_5" name="cbSubstanceTypeNasal_5" className='add-only' value="Nasal" />
                            Nasal &nbsp;
                            <input type="checkbox" id="cbSubstanceTypeSmoking_5" name="cbSubstanceTypeSmoking_5" className='add-only' value="Smoking" />
                            Smoking &nbsp;
                            <input type="checkbox" id="cbSubstanceTypeNonIvInjxn_5" name="cbSubstanceTypeNonIvInjxn_5" className='add-only' value="NonIvInjxn" />
                            Non-IV Injxn &nbsp;
                            <input type="checkbox" id="cbSubstanceTypeIv_5" name="cbSubstanceTypeIv_5" className='add-only' value="Iv" />
                            IV
                        </td>
                    </tr>
                </table>
                <h2>Physical</h2>
                <p className='w-750'>
                    <span className='eleHeader'>Current Medical Conditions</span>
                    <span className='small'>(Check all that apply)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPregnant" name="cbPregnant" className='add-only' value="Pregnant" />
                            Pregnant</td>
                        <td className='w-250'><span>Due date</span>
                            <input type="text" id="txtDueDate" name="txtDueDate" className='add-only' /></td>
                        <td className='w-250'><span>Prenatal care</span>
                            <input type="text" id="txtPrenatalCare" name="txtPrenatalCare" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbNoneReported" name="cbNoneReported" className='add-only' value="NoneReported" />
                            None Reported</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCongestiveHeartFailure" name="cbCongestiveHeartFailure" className='add-only' value="CongestiveHeartFailure" />
                            Congestive Heart Failure</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAsthma" name="cbAsthma" className='add-only' value="Asthma" />
                            Asthma</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSeizure" name="cbSeizure" className='add-only' value="Seizure" />
                            Seizure</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCancer" name="cbCancer" className='add-only' value="Cancer" />
                            Cancer</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbUnderweight" name="cbUnderweight" className='add-only' value="Underweight" />
                            Underweight</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbHighBloodPressure" name="cbHighBloodPressure" className='add-only' value="HighBloodPressure" />
                            High Blood Pressure</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbStroke" name="cbStroke" className='add-only' value="Stroke" />
                            Stroke</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEmphysema" name="cbEmphysema" className='add-only' value="Emphysema" />
                            Emphysema</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCirrhosis" name="cbCirrhosis" className='add-only' value="Cirrhosis" />
                            Cirrhosis</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbChronicPain" name="cbChronicPain" className='add-only' value="ChronicPain" />
                            Chronic Pain</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOverweight" name="cbOverweight" className='add-only' value="Overweight" />
                            Overweight</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbHeartDisease" name="cbHeartDisease" className='add-only' value="HeartDisease" />
                            Heart Disease</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDiabetes" name="cbDiabetes" className='add-only' value="Diabetes" />
                            Diabetes</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbEpilepsy" name="cbEpilepsy" className='add-only' value="Epilepsy" />
                            Epilepsy</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbDigestiveProblems" name="cbDigestiveProblems" className='add-only' value="DigestiveProblems" />
                            Digestive Problems</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThyroidDisease" name="cbThyroidDisease" className='add-only' value="ThyroidDisease" />
                            Thyroid Disease</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSexuallyTransmitted" name="cbSexuallyTransmitted" className='add-only' value="SexuallyTransmittedDz" />
                            Sexually Transmitted Dz</td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbOther" name="cbOther" className='add-only' value="Other" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtOther_1" name="txtOther_1" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Current & Past Medications Current</span>
                    <span className='small'>(Including non-psychotropic medications)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-200'><span>Medication Name</span></td>
                        <td className='w-75'><span>Dose</span></td>
                        <td className='w-75'><span>Freq.</span> </td>
                        <td className='w-75'><span>Route</span></td>
                        <td className='w-75'><span>Current</span></td>
                        <td className='w-250'>Comments (Reason Prescribed/Response, etc.)</td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input id="txtMedicationName_1" name="txtMedicationName_1" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtDose_1" name="txtDose_1" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtFreq_1" name="txtFreq_1" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtRoute_1" name="txtRoute_1" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <select id="ddlCurrent_1" name="ddlCurrent_1" className='add-only'>
                                <option value="Na"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                        <td className='w-250'>
                            <input id="txtcomment_1" name="txtcomment_1" type="text" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input id="txtMedicationName_2" name="txtMedicationName_2" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtDose_2" name="txtDose_2" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtFreq_2" name="txtFreq_2" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtRoute_2" name="txtRoute_2" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <select id="ddlCurrent_2" name="ddlCurrent_2" className='add-only'>
                                <option value="Na"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                        <td className='w-250'>
                            <input id="txtcomment_2" name="txtcomment_2" type="text" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input id="txtMedicationName_3" name="txtMedicationName_3" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtDose_3" name="txtDose_3" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtFreq_3" name="txtFreq_3" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtRoute_3" name="txtRoute_3" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <select id="ddlCurrent_3" name="ddlCurrent_3" className='add-only'>
                                <option value="Na"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                        <td className='w-250'>
                            <input id="txtcomment_3" name="txtcomment_3" type="text" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input id="txtMedicationName_4" name="txtMedicationName_4" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtDose_4" name="txtDose_4" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtFreq_4" name="txtFreq_4" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtRoute_4" name="txtRoute_4" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <select id="ddlCurrent_4" name="ddlCurrent_4" className='add-only'>
                                <option value="Na"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select>
                        </td>
                        <td className='w-250'>
                            <input id="txtcomment_4" name="txtcomment_4" type="text" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input id="txtMedicationName_5" name="txtMedicationName_5" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtDose_5" name="txtDose_5" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtFreq_5" name="txtFreq_5" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtRoute_5" name="txtRoute_5" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <select id="ddlCurrent_5" name="ddlCurrent_5" className='add-only'>
                                <option value="Na"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select></td>
                        <td className='w-250'>
                            <input id="txtcomment_5" name="txtcomment_5" type="text" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input id="txtMedicationName_6" name="txtMedicationName_6" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtDose_6" name="txtDose_6" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtFreq_6" name="txtFreq_6" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtRoute_6" name="txtRoute_6" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <select id="ddlCurrent_6" name="ddlCurrent_6" className='add-only'>
                                <option value="Na"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select></td>
                        <td className='w-250'>
                            <input id="txtcomment_6" name="txtcomment_6" type="text" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input id="txtMedicationName_7" name="txtMedicationName_7" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtDose_7" name="txtDose_7" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtFreq_7" name="txtFreq_7" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtRoute_7" name="txtRoute_7" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <select id="ddlCurrent_7" name="ddlCurrent_7" className='add-only'>
                                <option value="Na"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select></td>
                        <td className='w-250'>
                            <input id="txtcomment_7" name="txtcomment_7" type="text" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input id="txtMedicationName_8" name="txtMedicationName_8" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtDose_8" name="txtDose_8" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtFreq_8" name="txtFreq_8" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtRoute_8" name="txtRoute_8" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <select id="ddlCurrent_8" name="ddlCurrent_8" className='add-only'>
                                <option value="Na"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select></td>
                        <td className='w-250'>
                            <input id="txtcomment_8" name="txtcomment_8" type="text" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input id="txtMedicationName_9" name="txtMedicationName_9" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtDose_9" name="txtDose_9" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtFreq_9" name="txtFreq_9" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtRoute_9" name="txtRoute_9" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <select id="ddlCurrent_9" name="ddlCurrent_9" className='add-only'>
                                <option value="Na"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select></td>
                        <td className='w-250'>
                            <input id="txtcomment_9" name="txtcomment_9" type="text" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input id="txtMedicationName_10" name="txtMedicationName_10" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtDose_10" name="txtDose_10" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtFreq_10" name="txtFreq_10" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <input id="txtRoute_10" name="txtRoute_10" type="text" className='add-only' /></td>
                        <td className='w-75'>
                            <select id="ddlCurrent_10" name="ddlCurrent_10" className='add-only'>
                                <option value="Na"></option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </select></td>
                        <td className='w-250'>
                            <input id="txtcomment_10" name="txtcomment_10" type="text" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Allergies</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbNoReportedDrug" name="cbNoReportedDrug" className='add-only' value="NoReportedDrugOrFoodAllergies" />
                            No Reported Drug or Food Allergies
                        </td> 
                    </tr>
                    <tr> 
                        <td className='w-750'>
                            <input type="checkbox" id="cbOtherDescribeAllergies" name="cbOtherDescribeAllergies" className='add-only' value="OtherDescribeAllergies" />
                            Other/Describe:
                            <input type='text' id="txtOtherDescribeAllergies" name="txtOtherDescribeAllergies" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h2><b>Primary Care Physician</b></h2>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name</span>
                            <input type="text" id="txtName" name="txtName" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Phone</span>
                            <input type="text" id="txtPhone" name="txtPhone" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Fax</span>
                            <input type="text" id="txtFax" name="txtFax" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Additional Medical History</span>
                </p>

                <p className='w-750'>
                    <span className='small'>(Diagnosis, Hospitalizations, Surgery, labs values, status of conditions, etc.)</span>
                    <textarea id="txtAdditionalMedicalHistory" name="txtAdditionalMedicalHistory" className='add-only'></textarea>
                </p>
                <h1><b>Social</b></h1>
                <h3>Legal Status</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Current Legal Status</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLegal_1" name="cbLegal_1" className='add-only' value="None" />
                            None</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLegal_2" name="cbLegal_2" className='add-only' value="Parole" />
                            Parole</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLegal_3" name="cbLegal_3" className='add-only' value="Probation" />
                            Probation</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLegal_4" name="cbLegal_4" className='add-only' value="ChargesPending" />
                            Charges Pending</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLegal_6" name="cbLegal_6" className='add-only' value="Aot" />
                            AOT</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbLegal_7" name="cbLegal_7" className='add-only' value="Judicial" />
                            Judicial</td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type="checkbox" id="cbLegal_5" name="cbLegal_5" className='add-only' value="CourtOrderedOutpatientTreatment" />
                            Court-Ordered Outpatient Treatment</td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbLegal_8" name="cbLegal_8" className='add-only' value="Other" />
                            Other

                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comment/Detail</span>
                    <textarea id="txtLegal_Comment" name="txtLegal_Comment" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Past Legal Status</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPastLegalNone" name="cbPastLegalNone" className='add-only' value="None" />
                            None</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPastLegalDwi" name="cbPastLegalDwi" className='add-only' value="Dwi" />
                            DWI</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPastLegalPrioeArrests" name="cbPastLegalPrioeArrests" className='add-only' value="PriorArrests" />
                            Prior Arrests</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPastLegalPriorIncarcerations" name="cbPastLegalPriorIncarcerations" className='add-only' value="PriorIncarcerations" />
                            Prior Incarcerations</td>
                        <td className='w-250'></td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbPastLegalOther" name="cbPastLegalOther" className='add-only' value="Other" />
                            Other

                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Comment/Detail</span>
                    <textarea id="txtPastLegal_Comment" name="txtPastLegal_Comment" className='add-only'></textarea>
                </p>
                <h2>Family History
                    <span className='small'>(relationship status with relatives, family involvement in treatment, and living status of significant relatives)</span>
                </h2>
                <p className='w-750'>

                    <span className='eleHeader'>Custodial Status</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCustodialIndependantAdult" name="cbCustodialIndependantAdult" className='add-only' value="IndependantAdult" />
                            Independant Adult</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCustodialBiologicFather" name="cbCustodialBiologicFather" className='add-only' value="BiologicFather" />
                            Biologic Father</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCustodialBiologicMother" name="cbCustodialBiologicMother" className='add-only' value="BiologicMother" />
                            Biologic Mother</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCustodialJointBiologicParents" name="cbCustodialJointBiologicParents" className='add-only' value="JointBiologicParents" />
                            Joint Biologic Parents</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbCustodialGovtJudicial" name="cbCustodialGovtJudicial" className='add-only' value="GovtJudicial" />
                            Gov't/Judicial</td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbCustodialOther" name="cbCustodialOther" className='add-only' value="Other" />
                            Other

                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtCustodial_Other" name="txtCustodial_Other" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Contact Name</span>
                            <input  type="text" id="txtContactName" name="txtContactName" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Contact Relation</span>
                            <input type="text" id="txtContactRelation" name="txtContactRelation" className='add-only' />
                        </td>

                        <td className='w-250'>
                            <span className='eleHeader'>Contact Phone</span>
                            <input type="text" id="txtContactPhone" name="txtContactPhone" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Adverse Circumstances in Family of Origin:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAdverseFooNa" name="cbAdverseFooNa" className='add-only' value="Na" />
                            N/A</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAdverseFooPoverty" name="cbAdverseFooPoverty" className='add-only' value="Poverty" />
                            Poverty</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAdverseFooCriminalBehavior" name="cbAdverseFooCriminalBehavior" className='add-only' value="CriminalBehavior" />
                            Criminal Behavior</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAdverseFooMentalIllness" name="cbAdverseFooMentalIllness" className='add-only' value="MentalIllness" />
                            Mental Illness</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAdverseFooSubstanceUse" name="cbAdverseFooSubstanceUse" className='add-only' value="SubstanceUse" />
                            Substance Use</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAdverseFooAbuse" name="cbAdverseFooAbuse" className='add-only' value="Abuse" />
                            Abuse</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAdverseFooNeglect" name="cbAdverseFooNeglect" className='add-only' value="Neglect" />
                            Neglect</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAdverseFooDomesticViolence" name="cbAdverseFooDomesticViolence" className='add-only' value="DomesticViolence" />
                            Domestic Violence</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAdverseFooViolence" name="cbAdverseFooViolence" className='add-only' value="Violence" />
                            Violence</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAdverseFooTrauma" name="cbAdverseFooTrauma" className='add-only' value="Trauma" />
                            Trauma</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAdverseFooDivorce" name="cbAdverseFooDivorce" className='add-only' value="Divorce" />
                            Divorce</td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbAdverseFooOtherDescribe" name="cbAdverseFooOtherDescribe" className='add-only' value="AdverseFooOtherDescribe" />
                            Other/Describe:

                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtAdverseFooOtherDescribe" name="txtAdverseFooOtherDescribe" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Family Stress</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFamStressLowStress" name="cbFamStressLowStress" className='add-only' value="LowStress" />
                            Low Stress</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFamStressMildlyStressful" name="cbFamStressMildlyStressful" className='add-only' value="MildlyStressful" />
                            Mildly Stressful</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFamStressModeratelyStressful" name="cbFamStressModeratelyStressful" className='add-only' value="ModeratelyStressful" />
                            Moderately Stressful</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFamStressHighlyStressful" name="cbFamStressHighlyStressful" className='add-only' value="HighlyStressful" />
                            Highly Stressful</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFamStressExtremelyStressful" name="cbFamStressExtremelyStressful" className='add-only' value="ExtremelyStressful" />
                            Extremely Stressful</td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbFamStressOtherDescribe" name="cbFamStressOtherDescribe" className='add-only' value="FamStressOtherDescribe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtFamStressOtherDescribe" name="txtFamStressOtherDescribe" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Family Supports</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFamSupportsHighlySupportive" name="cbFamSupportsHighlySupportive" className='add-only' value="HighlySupportive" />
                            Highly Supportive</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFamSupportsSupportive" name="cbFamSupportsSupportive" className='add-only' value="Supportive" />
                            Supportive</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFamSupportsLimitedSupport" name="cbFamSupportsLimitedSupport" className='add-only' value="LimitedSupport" />
                            Limited Support</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFamSupportsMinimalSupport" name="cbFamSupportsMinimalSupport" className='add-only' value="MinimalSupport" />
                            Minimal Support</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFamSupportsNoSupport" name="cbFamSupportsNoSupport" className='add-only' value="NoSupport" />
                            No Support</td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbOtherDescribeFamilySupports" name="cbOtherDescribeFamilySupports" className='add-only' value="OtherDescribeFamilySupports" />
                            Other/Describe:

                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtOtherDescribeFamilySupports" name="txtOtherDescribeFamilySupports" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Additional Comments</span>
                    <textarea id="txtFamComments" name="txtFamComments" className='add-only'></textarea>
                </p>
                <h2>Trauma History</h2>
                <p className='w-750'>
                    <span className='eleHeader'>History of Trauma</span>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbTraumaHxNone" name="cbTraumaHxNone" className='add-only' value="None" />
                            None</td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbTraumaHxExperienced" name="cbTraumaHxExperienced" className='add-only' value="Experienced" />
                            Experienced</td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbTraumaHxWitnessed" name="cbTraumaHxWitnessed" className='add-only' value="Witnessed" />
                            Witnessed</td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbTraumaHxAbuse" name="cbTraumaHxAbuse" className='add-only' value="Abuse" />
                            Abuse</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type="checkbox" id="cbTraumaHxNeglect" name="cbTraumaHxNeglect" className='add-only' value="Neglect" />
                            Neglect</td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbTraumaHxViolence" name="cbTraumaHxViolence" className='add-only' value="Violence" />
                            Violence</td>
                        <td className='w-187'>
                            <input type="checkbox" id="cbTraumaHxSexualAssault" name="cbTraumaHxSexualAssault" className='add-only' value="SexualAssault" />
                            Sexual Assault</td>
                        <td className='w-187'></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbTraumaHxOtherDescribe" name="cbTraumaHxOtherDescribe" className='add-only' value="OtherDescribe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtTraumaHxOtherDescribe" name="txtTraumaHxOtherDescribe" className='add-only'></textarea>
                </p>
                <h2>Living Situation
                    <span className='small'>(Current status and functioning)</span>
                </h2>
                <p className='w-750'>

                    <span className='eleHeader'>a. Primary Residence</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPrimaryResideOwnHome" name="cbPrimaryResideOwnHome" className='add-only' value="OwnHome" />
                            Own Home</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPrimaryResideApartment" name="cbPrimaryResideApartment" className='add-only' value="Apartment" />
                            Apartment</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPrimaryResideRelativesHome" name="cbPrimaryResideRelativesHome" className='add-only' value="RelativesHome" />
                            Relative's Home</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPrimaryResideGroupHome" name="cbPrimaryResideGroupHome" className='add-only' value="GroupHome" />
                            Group Home</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPrimaryResideHomeless" name="cbPrimaryResideHomeless" className='add-only' value="Homeless" />
                            Homeless</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPrimaryResideLivingwithfriend" name="cbPrimaryResideLivingwithfriend" className='add-only' value="LivingWithfriendAcquaintance" />
                            Living with friend/acquaintance</td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbOtherDescribePrimaryResidence" name="cbOtherDescribePrimaryResidence" className='add-only' value="OtherDescribePrimaryResidence" />
                            Other/Describe:

                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtOtherDescribePrimaryResidence" name="txtOtherDescribePrimaryResidence" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>How long at current residence?</span>
                            <input type="text" id="txtLongCurrReside" name="txtLongCurrReside" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Level of time in community of residence?</span>
                            <input type="text" id="txtTimeCommReside" name="txtTimeCommReside" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Family/Household Composition</span>
                            <input type="text" id="txtFamilyComp" name="txtFamilyComp" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Source of meals/food</span>
                            <input type="text" id="txtFoodSource" name="txtFoodSource" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Means of transportation</span>
                            <input type="text" id="txtPrimaryReside_7" name="txtPrimaryReside_7" className='add-only' />
                        </td>
                        <td className='w-375'></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional Comments</span>
                    <span className='small'>(Include psychological and social adjustments made to disabilities and/or disorders.)</span>
                    <textarea id="txtLivSitComments" name="txtLivSitComments" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>b. Needs</span>
                    <span className='small'>List what is needed to improve/maintain daily living situation (Ex. Transportation, ability to cook independently, housing subsidy, money in savings, caregiver resource assessment, etc.)</span>
                    <textarea id="txtNeeds" name="txtNeeds" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>c. Preferences</span>
                    <span className='small'>Include things recipient feels will enhance his/her living situation.</span>
                    <textarea id="txtPreferences" name="txtPreferences" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>d. Strengths</span>
                    <span className='small'>List assets, service options, and resources the person has to meet needs, including available housing options. (Ex. Knows area, applied for housing subsidy, can live with family member, unpaid care-giver resource available, etc.)</span>
                    <textarea id="txtStrengths" name="txtStrengths" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>e. Abilities/Interests</span>
                    <span className='small'>Include recipient reported skills, aptitudes, capabilities, talents & competencies that might assist in maintaining or improving living situation.</span>
                    <textarea id="txtAbilities" name="txtAbilities" className='add-only'></textarea>
                </p>
                <h2>Learning/Working and Functional Status</h2>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>a. Employment/Education/Rehabilitation Status</span>
                            <input type="text" id="txtEmploymentStatus" name="txtEmploymentStatus" className='add-only w-700 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Source of Income</span>
                            <input type="text" id="txtCurrSourceIncome" name="txtCurrSourceIncome" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Estimated Monthly Income Amount</span>
                            <input type="text" id="txtEstIncome" name="txtEstIncome" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Highest Grade or Completed/Degree</span>
                            <input type="text" id="txtHighGrade" name="txtHighGrade" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Military Status</span>
                            <input type="text" id="txtMilitaryStatus" name="txtMilitaryStatus" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Military Trauma</span>
                            <input type="radio" id="rbMilitaryTrauma_Yes" name="rbMilitaryTrauma" className='add-only' value="Yes" />  Yes &nbsp;&nbsp;
                            <input type="radio" id="rbMilitaryTrauma_No" name="rbMilitaryTrauma" className='add-only' value="No" />  No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Difficulties with Reading/Writing</span>
                            <input type="radio" id="rbRWDiff_Yes" name="rbRWDiff" className='add-only' value="Yes" />  Yes &nbsp;&nbsp;
                            <input type="radio" id="rbRWDiff_No" name="rbRWDiff" className='add-only' value="No" />  No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Estimated Literacy Level</span>
                            <input type="text" id="txtEstLitLevel" name="txtEstLitLevel" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Employment Status</span>
                            <input type="text" id="txtCurrentEmpStatus" name="txtCurrentEmpStatus" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Prior Employment Status</span>
                            <input type="text" id="txtPriorEmpStatus" name="txtPriorEmpStatus" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Assistive Devices utilized/required:</span>
                            <input type="radio" id="rbAssistDev_Yes" name="rbAssistDev" className='add-only' value="Yes" />  Yes &nbsp;&nbsp;
                            <input type="radio" id="rbAssistDev_No" name="rbAssistDev" className='add-only' value="No" />  No
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional Comments</span>
                    <span className='small'>(Include psychological and social adjustments made to disabilities and/or disorders.)</span>
                    <textarea id="txtEmpAddComments" name="txtEmpAddComments" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>b. Current Status & Functioning</span>
                    <span className='small'>(Assess ability to fulfill responsibilities, interact with others, capacity self-care, missed activities, work or school due to health, etc.)</span>
                    <textarea id="txtCurrentFunctioning" name="txtCurrentFunctioning" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Functional Status Impairment Rating</span><span className='small'>(From LOCUS Functional Status Evaluation Parameters.)</span>
                </p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFsirMinimal" name="cbFsirMinimal" className='add-only' value="Minimal" />
                            Minimal</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFsirMild" name="cbFsirMild" className='add-only' value="Mild" />
                            Mild</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFsirModerate" name="cbFsirModerate" className='add-only' value="Moderate" />
                            Moderate</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFsirSerious" name="cbFsirSerious" className='add-only' value="Serious" />
                            Serious</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbFsirExtreme" name="cbFsirExtreme" className='add-only' value="Extreme" />
                            Extreme</td>
                        <td className='w-250'></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>As Evidenced By</span>
                    <textarea id="txtEvidencedBy" name="txtEvidencedBy" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>c. Needs</span>
                    <span className='small'>List what is needed to improve/maintain income, employment, education, vocational skills, etc. (Ex. Financial support, new skills, training, education, etc.)</span>
                    <textarea id="txtEmpNeeds" name="txtEmpNeeds" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Problems With Basic Needs</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbBasicNeedProblemsFood" name="cbBasicNeedProblemsFood" className='add-only' value="Food" />
                            Food</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbBasicNeedProblemsShelter" name="cbBasicNeedProblemsShelter" className='add-only' value="Shelter" />
                            Shelter</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbBasicNeedProblemsClothing" name="cbBasicNeedProblemsClothing" className='add-only' value="Clothing" />
                            Clothing</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbBasicNeedProblemsFunds" name="cbBasicNeedProblemsFunds" className='add-only' value="Funds" />
                            Funds</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbBasicNeedProblemsHealthcare" name="cbBasicNeedProblemsHealthcare" className='add-only' value="Healthcare" />
                            Healthcare</td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbBasicNeedProblemsAdls" name="cbBasicNeedProblemsAdls" className='add-only' value="Adls" />
                            ADLs</td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbOtherDescribeProblemsWithBasicNeeds" name="cbOtherDescribeProblemsWithBasicNeeds" className='add-only' value="OtherDescribeProblemsWithBasicNeeds" />
                            Other/Describe:

                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtOtherDescribeProblemsWithBasicNeeds" name="txtOtherDescribeProblemsWithBasicNeeds" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>d. Preferences</span>
                    <span className='small'>Include things recipient feels will enhance functional status with regard to income, employment, learning, literacy, etc.</span>
                    <textarea id="txtEduPreferences" name="txtEduPreferences" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>e. Strengths</span>
                    <span className='small'>List assets, service options, skills & resources recipient has to meet needs. (Ex. Intelligent, motivated, supportive family, education, job experience, interest in furthering education or vocational status, etc.)</span>
                    <textarea id="txtEduStrengths" name="txtEduStrengths" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>f. Abilities/Interests</span>
                    <span className='small'>Include recipient reported skills, aptitudes, capabilities, talents & competencies that might assist in maintaining or improving functional status.</span>
                    <textarea id="txtEduAbilities" name="txtEduAbilities" className='add-only'></textarea>
                </p>
                <h2>Social History and Community Integration</h2>
                <p className='w-750'>
                    <span className='eleHeader'>a. Current status and functioning</span><span className='small'>(Involvement in the community, social supports and activities, social barriers)</span>
                    <textarea id="txtCommunityIntegration" name="txtCommunityIntegration" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Does Recipient feel supported by friends or family?</span>
                    <input type="radio" id="rbYes9" name="rbRecipientFeel" className='add-only' value="Yes" /> Yes &nbsp;&nbsp;
                    <input type="radio" id="rbNo9" name="rbRecipientFeel" className='add-only' value="No" /> No
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Recreational Activities</span>
                    <textarea id="txtRecreationalActivities" name="txtRecreationalActivities" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Self-Help Activities</span>
                    <textarea id="txtSelfHelpActivities" name="txtSelfHelpActivities" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Additional Comments</span>
                    <span className='small'>(Include psychological and social adjustments made to disabilities and/or disorders.)</span>
                    <textarea id="txtAdditionalComments3" name="txtAdditionalComments3" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>b. Needs</span>
                    <span className='small'>List what is needed to improve/maintain recreation, social functioning & community integration. (Ex. Meet new people, painting supplies,
                        sports team,improve family relationships etc.)</span>
                    <textarea id="txtNeeds_2" name="txtNeeds_2" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>c. Preferences</span>
                    <span className='small'>Include things recipient feels will enhance or stimulate recreational interests, social functioning & community integration</span>
                    <textarea id="txtPreferences_2" name="txtPreferences_2" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>d. Strengths</span>
                    <span className='small'>List assets, service options & skills that may enhance socialization & community integration. (Ex. Friendly, athletic, independent,
                        friend plays, paints, past history of compliance in treatment, signs of resilience despite past adversity, etc.)</span>
                    <textarea id="txtStrengths2" name="txtStrengths2" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>e. Abilities/Interests</span>
                    <span className='small'>Include recipient reported skills, aptitudes, talents & competencies that may help maintain or improve socialization & community functioning</span>
                    <textarea id="txtAbilitiesInterests_2" name="txtAbilitiesInterests_2" className='add-only'></textarea>
                </p>
                <h2>Current Status</h2>
                <h3>Mental Status Examination</h3>
                <p className='w-750'>
                    <span className='small'>(Circle or Check all that apply.)</span>
                </p>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>a. General Appearance</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGeneralAppearanceHealthy" name="cbGeneralAppearanceHealthy" className='add-only' value="Healthy" />
                            Healthy
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGeneralAppearanceAsStatedAge" name="cbGeneralAppearanceAsStatedAge" className='add-only' value="AsstatedAge" />
                            As stated Age
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGeneralAppearanceOlderThanStatedAge" name="cbGeneralAppearanceOlderThanStatedAge" className='add-only' value="OlderThanStatedAge" />
                            Older Than Stated Age
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGeneralAppearanceYounglooking" name="cbGeneralAppearanceYounglooking" className='add-only' value="YoungLooking" />
                            Young-looking
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGeneralAppearanceTattoos" name="cbGeneralAppearanceTattoos" className='add-only' value="Tattoos" />
                            Tattoos
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGeneralAppearanceDisheveled" name="cbGeneralAppearanceDisheveled" className='add-only' value="Disheveled" />
                            Disheveled
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGeneralAppearanceUnkempt" name="cbGeneralAppearanceUnkempt" className='add-only' value="Unkempt" />
                            Unkempt
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGeneralAppearanceMalodorous" name="cbGeneralAppearanceMalodorous" className='add-only' value="Malodorous" />
                            Malodorous
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGeneralAppearanceThin" name="cbGeneralAppearanceThin" className='add-only' value="Thin" />
                            Thin
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGeneralAppearanceOverweight" name="cbGeneralAppearanceOverweight" className='add-only' value="Overweight" />
                            Overweight
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbGeneralAppearanceObese" name="cbGeneralAppearanceObese" className='add-only' value="Obese" />
                            Obese
                        </td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbGeneralAppearanceOtherDescribe" name="cbGeneralAppearanceOtherDescribe" className='add-only' value="OtherDescribe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtGeneralAppearance" name="txtGeneralAppearance" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <p className='w-750'>
                                <span className='eleHeader'>b. Behavior & Psychomotor Activity</span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPsychomotorActivityNormal" name="cbPsychomotorActivityNormal" className='add-only' value="Normal" />
                            Normal
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPsychomotorActivityOveractive" name="cbPsychomotorActivityOveractive" className='add-only' value="Overactive" />
                            Overactive
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPsychomotorActivityHypoactive" name="cbPsychomotorActivityHypoactive" className='add-only' value="Hypoactive" />
                            Hypoactive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPsychomotorActivityCatatonia" name="cbPsychomotorActivityCatatonia" className='add-only' value="Catatonia" />
                            Catatonia
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPsychomotorActivityTremor" name="cbPsychomotorActivityTremor" className='add-only' value="Tremor" />
                            Tremor
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPsychomotorActivityTics" name="cbPsychomotorActivityTics" className='add-only' value="Tics" />
                            Tics
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPsychomotorActivityCombative" name="cbPsychomotorActivityCombative" className='add-only' value="Combative" />
                            Combative
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPsychomotorActivityAbnormalGait" name="cbPsychomotorActivityAbnormalGait" className='add-only' value="AbnormalGait" />
                            Abnormal Gait
                        </td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbPsychomotorActivityOtherDescribe" name="cbPsychomotorActivityOtherDescribe" className='add-only' value="OtherDescribe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtPsychomotorActivity" name="txtPsychomotorActivity" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>c. Attitude</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAttitudeOptimal" name="cbAttitudeOptimal" className='add-only' value="Optimal" />
                            Optimal
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAttitudeConstructive" name="cbAttitudeConstructive" className='add-only' value="Constructive" />
                            Constructive
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAttitudeMotivated" name="cbAttitudeMotivated" className='add-only' value="Motivated" />
                            Motivated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAttitudeObstructive" name="cbAttitudeObstructive" className='add-only' value="Obstructive" />
                            Obstructive
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAttitudeAdversarial" name="cbAttitudeAdversarial" className='add-only' value="Adversarial" />
                            Adversarial
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAttitudeInaccessible" name="cbAttitudeInaccessible" className='add-only' value="Inaccessible" />
                            Inaccessible
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAttitudeCooperative" name="cbAttitudeCooperative" className='add-only' value="Cooperative" />
                            Cooperative
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAttitudeSeductive" name="cbAttitudeSeductive" className='add-only' value="Seductive" />
                            Seductive
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAttitudeDefensive" name="cbAttitudeDefensive" className='add-only' value="Defensive" />
                            Defensive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAttitudeHostile" name="cbAttitudeHostile" className='add-only' value="Hostile" />
                            Hostile
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAttitudeGuarded" name="cbAttitudeGuarded" className='add-only' value="Guarded" />
                            Guarded
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAttitudeApathetic" name="cbAttitudeApathetic" className='add-only' value="Apathetic" />
                            Apathetic
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAttitudeEvasive" name="cbAttitudeEvasive" className='add-only' value="Evasive" />
                            Evasive
                        </td>
                        <td className='w-250'></td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbAttitudeOtherExplain" name="cbAttitudeOtherExplain" className='add-only' value="OtherExplain" />
                            Other/Explain:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtAttitude" name="txtAttitude" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>d. Speech</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeechNormal" name="cbSpeechNormal" className='add-only' value="Normal" />
                            Normal
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeechSpontaneous" name="cbSpeechSpontaneous" className='add-only' value="Spontaneous" />
                            Spontaneous
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeechSlow" name="cbSpeechSlow" className='add-only' value="Slow" />
                            Slow
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeechImpoverished" name="cbSpeechImpoverished" className='add-only' value="Impoverished" />
                            Impoverished
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeechHesitant" name="cbSpeechHesitant" className='add-only' value="Hesitant" />
                            Hesitant
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeechMonotonous" name="cbSpeechMonotonous" className='add-only' value="Monotonous" />
                            Monotonous
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeechSoftWhispered" name="cbSpeechSoftWhispered" className='add-only' value="SoftWhispered" />
                            Soft/Whispered
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeechMumbled" name="cbSpeechMumbled" className='add-only' value="Mumbled" />
                            Mumbled
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeechRapid" name="cbSpeechRapid" className='add-only' value="Rapid" />
                            Rapid
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeechPressured" name="cbSpeechPressured" className='add-only' value="Pressured" />
                            Pressured
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeechVerbose" name="cbSpeechVerbose" className='add-only' value="Verbose" />
                            Verbose
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeechLoud" name="cbSpeechLoud" className='add-only' value="Loud" />
                            Loud
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeechSlurred" name="cbSpeechSlurred" className='add-only' value="Slurred" />
                            Slurred
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSpeechImpediment" name="cbSpeechImpediment" className='add-only' value="Impediment" />
                            Impediment
                        </td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbSpeechOtherDescribe" name="cbSpeechOtherDescribe" className='add-only' value="OtherDescribe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtSpeech" name="txtSpeech" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>e. Mood</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMoodDysphoric" name="cbMoodDysphoric" className='add-only' value="Dysphoric" />
                            Dysphoric
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMoodEuthymic" name="cbMoodEuthymic" className='add-only' value="Euthymic" />
                            Euthymic
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMoodExpansive" name="cbMoodExpansive" className='add-only' value="Expansive" />
                            Expansive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMoodIrritable" name="cbMoodIrritable" className='add-only' value="Irritable" />
                            Irritable
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMoodLabile" name="cbMoodLabile" className='add-only' value="Labile" />
                            Labile
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMoodElevated" name="cbMoodElevated" className='add-only' value="Elevated" />
                            Elevated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMoodEuphoric" name="cbMoodEuphoric" className='add-only' value="Euphoric" />
                            Euphoric
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMoodEcstatic" name="cbMoodEcstatic" className='add-only' value="Ecstatic" />
                            Ecstatic
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMoodDepressed" name="cbMoodDepressed" className='add-only' value="Depressed" />
                            Depressed
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMoodGriefMourning" name="cbMoodGriefMourning" className='add-only' value="Griefmourning" />
                            Grief/mourning
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMoodAlexithymic" name="cbMoodAlexithymic" className='add-only' value="Alexithymic" />
                            Alexithymic
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMoodElated" name="cbMoodElated" className='add-only' value="Elated" />
                            Elated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMoodHypomanic" name="cbMoodHypomanic" className='add-only' value="Hypomanic" />
                            Hypomanic
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMoodManic" name="cbMoodManic" className='add-only' value="Manic" />
                            Manic
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMoodAnxious" name="cbMoodAnxious" className='add-only' value="Anxious" />
                            Anxious
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMoodTense" name="cbMoodTense" className='add-only' value="Tense" />
                            Tense
                        </td>
                        <td className='w-250'></td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbMoodOtherDescribe" name="cbMoodOtherDescribe" className='add-only' value="OtherDescribe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtMood" name="txtMood" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>f. Affect</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffectAppropriate" name="cbAffectAppropriate" className='add-only' value="Appropriate" />
                            Appropriate
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffectInappropriate" name="cbAffectInappropriate" className='add-only' value="Inappropriate" />
                            Inappropriate
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffectBlunted" name="cbAffectBlunted" className='add-only' value="Blunted" />
                            Blunted
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffectRestricted" name="cbAffectRestricted" className='add-only' value="Restricted" />
                            Restricted
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffectFlat" name="cbAffectFlat" className='add-only' value="Flat" />
                            Flat
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffectLabile" name="cbAffectLabile" className='add-only' value="Labile" />
                            Labile
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffectTearful" name="cbAffectTearful" className='add-only' value="Tearful" />
                            Tearful
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbAffectIntense" name="cbAffectIntense" className='add-only' value="Intense" />
                            Intense
                        </td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td >
                            <input type="checkbox" id="cbAffectOtherDescribe" name="cbAffectOtherDescribe" className='add-only' value="OtherDescribe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtAffect" name="txtAffect" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>g. Perceptual Disturbances</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbPerceptualDisturbancesNone" name="cbPerceptualDisturbancesNone" className='add-only' value="None" />
                            None
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Hallucinations</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPerceptualDisturbancesAuditory" name="cbPerceptualDisturbancesAuditory" className='add-only' value="Auditory" />
                            Auditory
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPerceptualDisturbancesVisual" name="cbPerceptualDisturbancesVisual" className='add-only' value="Visual" />
                            Visual
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPerceptualDisturbancesOlfactory" name="cbPerceptualDisturbancesOlfactory" className='add-only' value="Olfactory" />
                            Olfactory
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbPerceptualDisturbancesTactile" name="cbPerceptualDisturbancesTactile" className='add-only' value="Tactile" />
                            Tactile
                        </td>
                        <td className='w-250'></td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbPerceptualDisturbancesOtherDescribe" name="cbPerceptualDisturbancesOtherDescribe" className='add-only' value="OtherDescribe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtPerceptualDisturbances" name="txtPerceptualDisturbances" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>h. Thought Process</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcessLogicalCoherent" name="cbThoughtProcessLogicalCoherent" className='add-only' value="LogicalCoherent" />
                            Logical/Coherent
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcessIncomprehensible" name="cbThoughtProcessIncomprehensible" className='add-only' value="Incomprehensible" />
                            Incomprehensible
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcessIncoherent" name="cbThoughtProcessIncoherent" className='add-only' value="Incoherent" />
                            Incoherent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcessFlightIdeas" name="cbThoughtProcessFlightIdeas" className='add-only' value="FlightOfIdeas" />
                            Flight of Ideas
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcessLooseAssociations" name="cbThoughtProcessLooseAssociations" className='add-only' value="LooseAssociations" />
                            Loose Associations
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcessTangential" name="cbThoughtProcessTangential" className='add-only' value="Tangential" />
                            Tangential
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcessCircumstantial" name="cbThoughtProcessCircumstantial" className='add-only' value="Circumstantial" />
                            Circumstantial
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcessRambling" name="cbThoughtProcessRambling" className='add-only' value="Rambling" />
                            Rambling
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcessEvasive" name="cbThoughtProcessEvasive" className='add-only' value="Evasive" />
                            Evasive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcessRacingThoughts" name="cbThoughtProcessRacingThoughts" className='add-only' value="RacingThoughts" />
                            Racing Thoughts
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcessPerseveration" name="cbThoughtProcessPerseveration" className='add-only' value="Perseveration" />
                            Perseveration
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcessThoughtBlocking" name="cbThoughtProcessThoughtBlocking" className='add-only' value="ThoughtBlocking" />
                            Thought Blocking
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtProcessConcrete" name="cbThoughtProcessConcrete" className='add-only' value="Concrete" />
                            Concrete
                        </td>
                        <td className='w-250'></td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbThoughtProcessOtherDescribe" name="cbThoughtProcessOtherDescribe" className='add-only' value="OtherDescribe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtThoughtProcess" name="txtThoughtProcess" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>i. Thought Content</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContentPreoccupations" name="cbThoughtContentPreoccupations" className='add-only' value="Preoccupations" />
                            Preoccupations
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContentObsessions" name="cbThoughtContentObsessions" className='add-only' value="Obsessions" />
                            Obsessions
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContentCompulsions" name="cbThoughtContentCompulsions" className='add-only' value="Compulsions" />
                            Compulsions
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContentPhobias" name="cbThoughtContentPhobias" className='add-only' value="Phobias" />
                            Phobias
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContentDelusions" name="cbThoughtContentDelusions" className='add-only' value="Delusions" />
                            Delusions
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContentThoughtBroadcasting" name="cbThoughtContentThoughtBroadcasting" className='add-only' value="ThoughtBroadcasting" />
                            Thought Broadcasting
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContentThoughtInsertion" name="cbThoughtContentThoughtInsertion" className='add-only' value="ThoughtInsertion" />
                            Thought Insertion
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContentThoughtWithdrawal" name="cbThoughtContentThoughtWithdrawal" className='add-only' value="ThoughtWithdrawal" />
                            Thought Withdrawal
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContentIdeasReference" name="cbThoughtContentIdeasReference" className='add-only' value="IdeasOfReference" />
                            Ideas of Reference
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbThoughtContentIdeasInfluence" name="cbThoughtContentIdeasInfluence" className='add-only' value="IdeasOfInfluence" />
                            Ideas of Influence
                        </td>
                        <td className='w-250'></td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbThoughtContentOtherDescribe" name="cbThoughtContentOtherDescribe" className='add-only' value="OtherDescribe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtThoughtContent" name="txtThoughtContent" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>j. Suicidal/Homicidal Ideation</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSHIdeationSuicidalThoughts" name="cbSHIdeationSuicidalThoughts" className='add-only' value="SuicidalThoughts" />
                            Suicidal Thoughts
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSHIdeationSuicidalAttempts" name="cbSHIdeationSuicidalAttempts" className='add-only' value="SuicidalAttempts" />
                            Suicidal Attempts
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSHIdeationSuicidalIntent" name="cbSHIdeationSuicidalIntent" className='add-only' value="SuicidalIntent" />
                            Suicidal Intent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSHIdeationSuicidalPlans" name="cbSHIdeationSuicidalPlans" className='add-only' value="SuicidalPlans" />
                            Suicidal Plans
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSHIdeationHistoryBehavior" name="cbSHIdeationHistoryBehavior" className='add-only' value="HistoryOfSelfInjuriousBehavior" />
                            History of Self-Injurious Behavior
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSHIdeationHomicidalThoughts" name="cbSHIdeationHomicidalThoughts" className='add-only' value="HomicidalThoughts" />
                            Homicidal Thoughts
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSHIdeationHomicidalAttempts" name="cbSHIdeationHomicidalAttempts" className='add-only' value="HomicidalAttempts" />
                            Homicidal Attempts
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSHIdeationHomicidalIntent" name="cbSHIdeationHomicidalIntent" className='add-only' value="HomicidalIntent" />
                            Homicidal Intent
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSHIdeationHomicidalPlans" name="cbSHIdeationHomicidalPlans" className='add-only' value=" HomicidalPlans" />
                            Homicidal Plans
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbSHIdeationOtherDescribe" name="cbSHIdeationOtherDescribe" className='add-only' value="OtherDescribe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtSHIdeation" name="txtSHIdeation" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>k. Sensorium/Cognition</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSensoriumAlert" name="cbSensoriumAlert" className='add-only' value="Alert" />
                            Alert
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSensoriumLethargic" name="cbSensoriumLethargic" className='add-only' value="Lethargic" />
                            Lethargic
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSensoriumSomnolent" name="cbSensoriumSomnolent" className='add-only' value="Somnolent" />
                            Somnolent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSensoriumStuporous" name="cbSensoriumStuporous" className='add-only' value="Stuporous" />
                            Stuporous
                        </td>
                        <td className='w-250'></td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Oriented to</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOrientedToPerson" name="cbOrientedToPerson" className='add-only' value="Person" />
                            Person
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOrientedToPlace" name="cbOrientedToPlace" className='add-only' value="Place" />
                            Place
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOrientedToTime" name="cbOrientedToTime" className='add-only' value="Time" />
                            Time
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOrientedToSituation" name="cbOrientedToSituation" className='add-only' value="Situation" />
                            Situation
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOrientedToNormalConcentration" name="cbOrientedToNormalConcentration" className='add-only' value="NormalConcentration" />
                            Normal Concentration
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbOrientedToImpairedConcentration" name="cbOrientedToImpairedConcentration" className='add-only' value="ImpairedConcentration" />
                            Impaired Concentration
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbOrientedToOtherDescribe" name="cbOrientedToOtherDescribe" className='add-only' value="OtherDescribe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtOrientedTo" name="txtOrientedTo" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>l. Memory</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span>Remote Memory</span>
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbRemoteMemoryNormal" name="rbRemoteMemory" className='add-only' value="Normal" />
                            Normal
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbRemoteMemoryImpaired" name="rbRemoteMemory" className='add-only' value="Impaired" />
                            Impaired
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span>Recent Memory</span>
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbRecentMemoryNormal" name="rbRecentMemory" className='add-only' value="Normal" />
                            Normal
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbRecentMemoryImpaired" name="rbRecentMemory" className='add-only' value="Impaired" />
                            Impaired
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            {/*Doubt eleHeader */}
                            {/*Doubt eleHeader */}
                            <span className='eleHeader'>Immediate Recall </span>
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbImmediateRecallNormal" name="rbImmediateRecall" className='add-only' value="Normal" />
                            Normal
                        </td>
                        <td className='w-250'>
                            <input type="radio" id="rbImmediateRecallImpaired" name="rbImmediateRecall" className='add-only' value="Impaired" />
                            Impaired
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbOtherMemory" name="cbOtherMemory" className='add-only' value="OtherDescribe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtOtherMemory" name="txtOtherMemory" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>m. Intellectual Functioning</span><span className='small'>(Estimate)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIntellectualFunctioninAboveAvg" name="cbIntellectualFunctioningAboveAvg" className='add-only' value="AboveAvg" />
                            Above Avg.
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIntellectualFunctioningNormalAvg" name="cbIntellectualFunctioningNormalAvg" className='add-only' value="NormalAvg" />
                            Normal/Avg.
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIntellectualFunctioningBorderline" name="cbIntellectualFunctioningBorderline" className='add-only' value="Borderline" />
                            Borderline.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Intellectual Disability</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIntellectualDisabilityMild" name="cbIntellectualDisabilityMild" className='add-only' value="Mild" />
                            Mild
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIntellectualDisabilityModerate" name="cbIntellectualDisabilityModerate" className='add-only' value="Moderate" />
                            Moderate
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbIntellectualDisabilitySevere" name="cbIntellectualDisabilitySevere" className='add-only' value="Severe" />
                            Severe
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbIntellectualDisabilityOtherDescribe" name="cbIntellectualDisabilityOtherDescribe" className='add-only' value="OtherDescribe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtIntellectualDisability" name="txtIntellectualDisability" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>n. Judgement</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbJudgementCriticalJudgmentIntact" name="cbJudgementCriticalJudgmentIntact" className='add-only' value="CriticalJudgmentIntact" />
                            Critical JudgmentIntact
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbJudgementImpairedJudgment" name="cbJudgementImpairedJudgment" className='add-only' value="ImpairedJudgment" />
                            Impaired Judgment
                        </td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbJudgementOtherDescribe" name="cbJudgementOtherDescribe" className='add-only' value="OtherDescribe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtJudgement" name="txtJudgement" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>o. Insight</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbInsightTrueEmotionalInsight" name="cbInsightTrueEmotionalInsight" className='add-only' value="TrueEmotionalInsight" />
                            TrueEmotionalInsight
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbInsightIntellectualInsight" name="cbInsightIntellectualInsight" className='add-only' value="IntellectualInsight" />
                            IntellectualInsight
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbInsightImpairedInsight" name="cbInsightImpairedInsight" className='add-only' value="ImpairedInsight" />
                            ImpairedInsight
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type="checkbox" id="cbInsightSomeAwarenessIllnessSymptoms" name="cbInsightSomeAwarenessIllnessSymptoms" className='add-only' value="SomeAwarenessOfIllnessSymptoms" />
                            SomeAwarenessIllnessSymptoms
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbInsightDenial" name="cbInsightDenial" className='add-only' value="Denial" />
                            Denial
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbInsightOtherDescribe" name="cbInsightOtherDescribe" className='add-only' value="OtherDescribe" />
                            OtherDescribe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtInsight" name="txtInsight" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>p. Impulse Control</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImpulseControlAbleResistImpulses" name="cbImpulseControlAbleResistImpulses" className='add-only' value="AbleToResistImpulses" />
                            Able to Resist Impulses
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImpulseControlRecentImpulsiveBehavior" name="cbImpulseControlRecentImpulsiveBehavior" className='add-only' value="RecentImpulsiveBehavior" />
                            Recent Impulsive Behavior
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImpulseControlImpairedImpulseControl" name="cbImpulseControlImpairedImpulseControl" className='add-only' value="ImpairedImpulseControl" />
                            Impaired Impulse Control
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbImpulseControlCompulsions" name="cbImpulseControlCompulsions" className='add-only' value="Compulsions" />
                            Compulsions
                        </td>
                        <td className='w-250'></td>
                        <td className='w-250'></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbImpulseControlOtherDescribe" name="cbImpulseControlOtherDescribe" className='add-only' value="OtherDescribe" />Other/Describe:
                            <input type="text" id="txtImpulseControl" name="txtImpulseControl" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtImpulseControl" name="txtImpulseControl" className='add-only'></textarea>
                </p>
                <h3>Risk Assessment
                    <p className='w-750'>
                        <span className='small'>Assess potential risk of harm to self or others, including patterns of risk behavior and/or risk due to personality factors, substance use,
                            criminogenic factors, exposure to elements, exploitation, abuse, neglect, suicidal or homicidal history, self-injury, psychosis, impulsiveness, etc.</span>
                    </p>
                </h3>
                <p className='w-750'>

                    <span className='eleHeader'>a. Risk of Harm to Self</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRhsPriorSuicideAttempt" name="cbRhsPriorSuicideAttempt" className='add-only' value="PriorSuicideAttempt" />
                            Prior Suicide Attempt</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRhsStatedPlanIntent" name="cbRhsStatedPlanIntent" className='add-only' value="StatedPlanIntent" />
                            Stated Plan/Intent</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRhsAccessMeans" name="cbRhsAccessMeans" className='add-only' value="AccessTomeans" />
                            Access to means (weapons, pills, etc.)</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRhsRecentLoss" name="cbRhsRecentLoss" className='add-only' value="RecentLoss" />
                            Recent Loss</td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRhsFamilyHistorySuicide" name="cbRhsFamilyHistorySuicide" className='add-only' value="FamilyHistoryOfSuicide" />
                            Family History of Suicide</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRhsTerminalIllness" name="cbRhsTerminalIllness" className='add-only' value="TerminalIllness" />
                            Terminal Illness</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRhsSubstanceAbuse" name="cbRhsSubstanceAbuse" className='add-only' value="SubstanceAbuse" />
                            Substance Abuse</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRhsMarkedLacksupport" name="cbRhsMarkedLacksupport" className='add-only' value="MarkedLackOfsupport" />
                            Marked lack of support</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRhsPsychosis" name="cbRhsPsychosis" className='add-only' value="Psychosis" />
                            Psychosis</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRhsSuicideFriendAcquaintance" name="cbRhsSuicideFriendAcquaintance" className='add-only' value="SuicideOffriendAcquaintance" />
                            Suicide of friend/acquaintance</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbRhsPresenceBehavioralCues" name="cbRhsPresenceBehavioralCues" className='add-only' value="PresenceOfBehavioralCues" />
                            Presence of Behavioral Cues (isolation, giving away possessions, rapid mood swings, etc.)</td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbRhsOtherDescribe" name="cbRhsOtherDescribe" className='add-only' value="OtherDescribe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtOtherDescribe" name="txtOtherDescribe" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>b. Risk of Harm to Others</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbRhoPriorActsViolence" name="cbRhoPriorActsViolence" className='add-only' value="PriorSuicideAttempt" />
                            PriorActsViolence if yes, when was most recent violent act? &nbsp;&nbsp;
                            <input type="text" id="txtRhoPriorActsViolence" name="txtRhoPriorActsViolence" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRhoDestructionProperty" name="cbRhoDestructionProperty" className='add-only' value="DestructionOfproperty" />
                            DestructionProperty</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRhoArrestsViolence" name="cbRhoArrestsViolence" className='add-only' value="ArrestsForviolence" />
                            ArrestsViolence</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRhoAccessMeans" name="cbRhoAccessMeans" className='add-only' value="AccessTomeans" />
                            AccessMeans (weapons)</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRhoSubstanceUse" name="cbRhoSubstanceUse" className='add-only' value="SubstanceUse" />
                            SubstanceUse</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRhoPhysicallyAbusedChild" name="cbRhoPhysicallyAbusedChild" className='add-only' value="PhysicallyAbusedAsChild" />
                            PhysicallyAbusedChild</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRhoWasPhysicallyAbusiveChild" name="cbRhoWasPhysicallyAbusiveChild" className='add-only' value="WasPhysicallyAbusiveAsChild" />
                            WasPhysicallyAbusiveChild</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRhoHarmsAnimals" name="cbRhoHarmsAnimals" className='add-only' value="HarmsAnimals" />
                            HarmsAnimals</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRhoFireSetting" name="cbRhoFireSetting" className='add-only' value="FireSetting" />
                            FireSetting</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRhoAngryMoodAgitation" name="cbRhoAngryMoodAgitation" className='add-only' value="AngryMoodAgitation" />
                            AngryMoodAgitation</td>
                        <td className='w-375'>
                            <input type="checkbox" id="cbRhoPriorHospitalizationsDangerOthers" name="cbRhoPriorHospitalizationsDangerOthers" className='add-only' value="PriorHospitalizationsForDangerToOthers" />
                            PriorHospitalizationsDangerOthers</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbRhoPsychosisCommandHallucinations" name="cbRhoPsychosisCommandHallucinations" className='add-only' value="Psychosis" />
                            PsychosisCommandHallucinations (If yes, is there history of acting on any commands to harm others?)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="radio" id="rbRhoPsychosisCommandHallucinationsYes" name="rbRhoPsychosisCommandHallucinations" className='add-only' value="Yes" /> Yes &nbsp;&nbsp;
                            <input type="radio" id="rbRhoPsychosisCommandHallucinationsNo" name="rbRhoPsychosisCommandHallucinations" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="checkbox" id="cbRhoOtherDescribe" name="cbRhoOtherDescribe" className='add-only' value="OtherDescribe" />
                            OtherDescribe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtRho" name="txtRho" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>c. Risk of Harm to Self or Others Rating</span>
                    <span className='small'>(From LOCUS Risk of Harm Evaluation Parameters.)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRHSelfMinimal" name="cbRHSelfMinimal" className='add-only' value="Minimal" />
                            Minimal       </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRHSelfLow" name="cbRHSelfLow" className='add-only' value="Low" />
                            Low
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRHSelfModerate" name="cbRHSelfModerate" className='add-only' value="Moderate" />
                            Moderate
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRHSelfSerious" name="cbRHSelfSerious" className='add-only' value="Serious" />Serious
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbRHSelfExtreme" name="cbRHSelfExtreme" className='add-only' value="Extreme" />Extreme
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>As Evidenced By</span>
                    <textarea id="txtAsEvidencedBy2" name="txtAsEvidencedBy2" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>d. Recipient Safety & Other Risk Factors</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbFeelsnsafeEnvironment" name="cbFeelsnsafeEnvironment" className='add-only' value="FeelsEnvironment" />
                            Feels unsafe in current living environment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbFeelsCurrentlySomeone" name="cbFeelsCurrentlySomeone" className='add-only' value="FeelsCurrentlySomeone" />
                            Feels currently being harmed/hurt/abused/threatened by someone
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbEngagesSexualBehavior" name="cbEngagesSexualBehavior" className='add-only' value="EngagesSexualBehavior" />
                            Engages in dangerous sexual behavior
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbPastInvolvementChildAdultProtectiveServices" name="cbPastInvolvementChildAdultProtectiveServices" className='add-only' value="PastInvolvementChildAdultProtectiveServices" />
                            Past involvement with Child or Adult Protective Services
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbRelapseDecompensationTriggers" name="cbRelapseDecompensationTriggers" className='add-only' value="RelapseDecompensationTriggers" />
                            Relapse/decompensation triggers
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbRecipientSafetyOtherDescribe" name="cbRecipientSafetyOtherDescribe" className='add-only' value="OtherDescribe" />
                            Other/Describe:
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtRecipientSafetyOtherDescribe" name="txtRecipientSafetyOtherDescribe" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>e. Preferences and Desires</span>
                    <span className='small'>Describe recipient's preferences and desires for addressing risk factors, including any Mental Health Advance Directives or plan of response to
                        periods of decompensation/relapse (Ex. Resources recipient feels comfortable reaching out to for assistance in a crisis.): </span>
                    <textarea id="txtPreferencesAndDesires" name="txtPreferencesAndDesires" className='add-only'></textarea>
                </p>
                <h2>Cultural & Language Preferences
                    <span className='small'>(Language, Customs/Values/Preferences)</span>
                </h2>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>a. Spiritual Beliefs/Preferences</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtSpiritualBeliefs" name="txtSpiritualBeliefs" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>b. Cultural Beliefs/Preferences</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtCulturalBeliefs" name="txtCulturalBeliefs" className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Principal Diagnosis </span>
                    <span className='small'>(Provide principle behavioral and medical diagnoses)</span>
                    <textarea id="txtPrincipalDiagnosis" name="txtPrincipalDiagnosis" className='add-only'></textarea>
                </p>
                <h2>Principal Diagnosis</h2>
                <span className='small'>(Provide principle behavioral and medical diagnoses)</span>
                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Code</span>
                        </td>
                        <td className='w-600'>
                            <span className='eleHeader'>Description</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtPrincipalDiagnosisCode_1" name="txtPrincipalDiagnosisCode_1" className='add-only' /></td>
                        <td className='w-550'>
                            <input type="text" id="txtPrincipalDiagnosisDesc_1" name="txtPrincipalDiagnosisDesc_1" className='add-only w-550 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtPrincipalDiagnosisCode_2" name="txtPrincipalDiagnosisCode_2" className='add-only' /></td>
                        <td className='w-550'>
                            <input type="text" id="txtPrincipalDiagnosisDesc_2" name="txtPrincipalDiagnosisDesc_2" className='add-only w-550 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtPrincipalDiagnosisCode_3" name="txtPrincipalDiagnosisCode_3" className='add-only' /></td>
                        <td className='w-550'>
                            <input type="text" id="txtPrincipalDiagnosisDesc_3" name="txtPrincipalDiagnosisDesc_3" className='add-only w-550 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="text" id="txtPrincipalDiagnosisCode_4" name="txtPrincipalDiagnosisCode_4" className='add-only' /></td>
                        <td className='w-550'>
                            <input type="text" id="txtPrincipalDiagnosisDesc_4" name="txtPrincipalDiagnosisDesc_4" className='add-only w-550 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input  type="text"id="txtPrincipalDiagnosisCode_5" name="txtPrincipalDiagnosisCode_5" className='add-only' /></td>
                        <td className='w-550'>
                            <input type="text" id="txtPrincipalDiagnosisDesc_5" name="txtPrincipalDiagnosisDesc_5" className='add-only w-550 custom-add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Interpretive Summary </span>
                    <span className='small'>Describe recipient's global preferences/hopes for recovery, recommended treatments/assessments, level of care, duration. Include clinical/central theme, co-occurring disabilities, environmental and personal supports/needs.</span>
                    <textarea id="txtInterpretativeSummary" name="txtInterpretativeSummary" className='add-only'></textarea>
                </p>
                <h2>Identified Needs</h2>
                <table>
                    <tr>
                        <td className='w-700'>1.&nbsp;
                            <input type="text" id="txtIdentifiedNeeds_1" name="txtIdentifiedNeeds_1" className='custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-700'>2.&nbsp;
                            <input type="text" id="txtIdentifiedNeeds_2" name="txtIdentifiedNeeds_2" className='custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-700'>3.&nbsp;
                            <input type="text" id="txtIdentifiedNeeds_3" name="txtIdentifiedNeeds_3" className='custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-700'>4.&nbsp;
                            <input type="text" id="txtIdentifiedNeeds_4" name="txtIdentifiedNeeds_4" className='custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-700'>5.&nbsp;
                            <input type="text" id="txtIdentifiedNeeds_5" name="txtIdentifiedNeeds_5" className='custom-add-only' />
                        </td>
                    </tr>
                </table>
                <h2>Recommended Services</h2>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>MH Services</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMhServicesAct" name="cbMhServicesAct" className='add-only' value="Act" />
                            ACT(21+)
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMhServicesCpst" name="cbMhServicesCpst" className='add-only' value="Cpst" />
                            CPST(21+)
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMhServicesPsrIndividual" name="cbMhServicesPsrIndividual" className='add-only' value="PsrIndividual" />
                            PSR(21+)-Individual
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMhServicesPsrGroup" name="cbMhServicesPsrGroup" className='add-only' value="PsrGroup" />
                            PSR(21+)-Group
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMhServicesPsh" name="cbMhServicesPsh" className='add-only' value="Psh" />
                            PSH
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMhServicesMedMgt" name="cbMhServicesMedMgt" className='add-only' value="MedMgt" />
                            Med Mgt
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMhServicesOutptTherapyInd" name="cbMhServicesOutptTherapyInd" className='add-only' value="OutptTherapy" />
                            Outpt Therapy (Ind)
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMhServicesOutptTherapyFam" name="cbMhServicesOutptTherapyFam" className='add-only' value="OutptTherapyFam" />
                            Outpt Therapy (Fam)
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbMhServicesOutptTherapyGroup" name="cbMhServicesOutptTherapyGroup" className='add-only' value="OutptTherapyGroup" />
                            Outpt Therapy (Group)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>SA Services</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSaServicesResidentialTx" name="cbSaServicesResidentialTx" className='add-only' value="ResidentialTx" />
                            Residential Tx
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSaServicesHalfwayHouse" name="cbSaServicesHalfwayHouse" className='add-only' value="HalfwayHouse" />
                            Halfway House
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSaServicesIop" name="cbSaServicesIop" className='add-only' value="Iop" />
                            IOP
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSaServicesAmbulatoryDetox" name="cbSaServicesAmbulatoryDetox" className='add-only' value="AmbulatoryDetox" />
                            Ambulatory Detox
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSaServicesOutptTherapyInd1" name="cbSaServicesOutptTherapyInd1" className='add-only' value="OutptTherapyInd1" />
                            Outpt Therapy (Ind)
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSaServicesOutptTherapyFam1" name="cbSaServicesOutptTherapyFam1" className='add-only' value="OutptTherapyFam1" />
                            Outpt Therapy (Fam)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbSaServicesOutptTherapyGroup1" name="cbSaServicesOutptTherapyGroup1" className='add-only' value="OutptTherapyGroup1" />
                            Outpt Therapy (Group)
                        </td>
                        <td className='w-250'></td>
                        <td className='w-250'></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Other (with explanation)</span>
                    <textarea id="txtOtherWithExplanation" name="txtOtherWithExplanation" className='add-only'></textarea>
                </p>

                <h2>Signature</h2>
                <table>
                    <tr>
                        <td className="signature w-187">&nbsp;
                        </td>
                        <td className="signature w-187">&nbsp;
                        </td>
                        <td className="signature w-187">&nbsp;
                        </td>
                        <td className="signature w-187">&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className="small w-187">Printed Name of Assessor
                        </td>
                        <td className="small w-187">Signature
                        </td>
                        <td className="small w-187">LMHP Status
                        </td>
                        <td className="small w-187">Date
                        </td>
                    </tr>
                </table>


            </div>
        </form >

    )
}





